"use strict";
import React from "react";
import ReactDOM from "react-dom";
import _ from "underscore";
import Account from "../../api/account";
import AutoConfirmedLoadHeader from "../auto_confirmed_load_header";
import InvoiceInputFieldsOwnerMixin from "./invoice_input_fields_owner_mixin";
import LoadAssignerProgress, {
  getLoadAssignerProgressItems
} from "./load_assigner_progress";
import LoadTable from "./load_table";
import LoadSearchArea from "./load_search_area";
import DocumentExceptionArea from "./document_exception_area";
import CarrierChooser from "./carrier_chooser";
import CarrierInvoiceChooser from "./carrier_invoice_chooser";
import DocumentTitle from "react-document-title";
import { History } from "react-router";
import reactUtils from "../../react_utils";
import ToDashboardWithFilters from "../ui/to_dashboard_with_filters";
import Auth from "../../util/auth";
var bem = reactUtils.makeBem("document-group-editor");
function hasGuessedLoad(props) {
  return props.loads.guessed.length > 0 || props.loads.selected;
}
export default React.createClass({
  mixins: [InvoiceInputFieldsOwnerMixin, History],
  noInvoice: { id: "none" },
  getInitialState: function() {
    const guessedLoad = hasGuessedLoad(this.props);
    return {
      showExceptions: _.first(this.activeExceptions()),
      showSearch: !guessedLoad,
      showGuessed: guessedLoad,
      source_invoice_amount: null,
      source_invoice_number: null
    };
  },
  componentDidMount: function() {
    if (hasGuessedLoad(this.props)) {
      this.focusNextField();
    }
  },
  componentWillReceiveProps: function(nextProps) {
    if (this.props.group !== nextProps.group) {
      const guessedLoad = hasGuessedLoad(nextProps);
      this.setState({
        showExceptions: _.first(this.activeExceptions(nextProps)),
        showSearch: !guessedLoad,
        showGuessed: guessedLoad
      });
    }
    if (nextProps.saving !== this.props.saving) {
      this.setState({ saving: nextProps.saving });
    }
  },
  // STATE
  hasInvoices: function() {
    return this.props.invoicesForGroup.length > 0;
  },
  selectedLoadHasCustomerCustomExceptionMessages: function() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
    return ((_e = (_d = (_c = (_b = (_a = this.props.loads.selectedLoad) == null ? void 0 : _a.load) == null ? void 0 : _b.customer) == null ? void 0 : _c.settings["rules_broker_custom_exception_messages"]) == null ? void 0 : _d.length) != null ? _e : 0) > 0 || ((_j = (_i = (_h = (_g = (_f = this.props.loads.selectedLoad) == null ? void 0 : _f.load) == null ? void 0 : _g.tms_load_shipments) == null ? void 0 : _h.flatMap(
      (s) => {
        var _a2;
        return (_a2 = s.customer_broker_custom_plain_text_rules) != null ? _a2 : [];
      }
    )) == null ? void 0 : _i.length) != null ? _j : 0) > 0;
  },
  rerouteNidfToException: function() {
    return Auth.getCurrentUser().managed_indexer && Account.preventNidfToLoadWithCustomerCustomExceptionMessagesEnabled() && this.selectedLoadHasCustomerCustomExceptionMessages();
  },
  assignLoad() {
    var selectedLoadId = this.props.loads.selected;
    this.setState({ saving: true });
    const carrierID = this.props.selectedCarrierID;
    const carrierInvoice = {};
    ["source_invoice_number", "source_invoice_amount"].forEach((field) => {
      if (this.state[field]) {
        carrierInvoice[field] = this.state[field];
      }
    });
    if (this.hasInvoices() && this.props.getSelectedInvoiceForGroup(this.noInvoice).id !== this.noInvoice.id) {
      this.props.assignCurrentGroupToLoadAndInvoiceId(
        selectedLoadId,
        this.props.getSelectedInvoiceForGroup(this.noInvoice).id,
        carrierInvoice,
        carrierID,
        false,
        null
      );
      return;
    }
    if (this.rerouteNidfToException()) {
      this.props.exceptionCreator("Custom rules found for this customer", false).then(() => {
        if (!this.props.hasMore) {
          console.log("to dashboard with filters");
          ToDashboardWithFilters(this.props.location, this.history);
        } else {
          console.log("documents exception added callback");
          this.props.documentsExceptionAddedCallback();
        }
      });
      return;
    }
    this.props.assignCurrentGroupToLoad(selectedLoadId, carrierID).then(() => this.setState({ saving: false }));
  },
  toggleExceptions: function() {
    this.setState({ showExceptions: !this.state.showExceptions });
  },
  showSearch: function() {
    this.setState({ showSearch: true });
  },
  cancelSearch: function() {
    this.setState({ showSearch: false });
    this.focusNextField();
  },
  carrierSelected: function(carrier) {
    this.setState({ carrier });
  },
  // RENDER
  render: function() {
    return /* @__PURE__ */ React.createElement(DocumentTitle, { title: "TriumphPay Audit \u2013 Assign Loads" }, /* @__PURE__ */ React.createElement("div", { className: "load-assigner__root", ref: "container" }, /* @__PURE__ */ React.createElement("div", { className: "load-assigner__scrollable-area" }, this.reportProblemContent(), this.assignLoadsContent()), this.progressArea()));
  },
  showAssignLoadsContent: function() {
    return (!this.state.showExceptions || this.state.showExceptions && this.activeExceptions().length > 0) && !this.state.recentlyResolved;
  },
  assignLoadsContent: function() {
    if (this.showAssignLoadsContent()) {
      return /* @__PURE__ */ React.createElement("div", null, this.assignLoadsHeader(), this.selectLoadText(), this.documentGroup(), this.possibleExceptionsLink());
    }
  },
  assignLoadsHeader: function() {
    var selectedLoad = this.props.loads.selectedLoad;
    var text = "Assign Load to This Document Group";
    if (selectedLoad && !selectedLoad.load.load_is_auto_confirmed) {
      return /* @__PURE__ */ React.createElement("h3", null, text);
    } else if (!selectedLoad) {
      return /* @__PURE__ */ React.createElement("h3", null, text);
    }
  },
  documentGroup: function() {
    return /* @__PURE__ */ React.createElement("div", { className: bem("__group") }, /* @__PURE__ */ React.createElement("div", { className: bem("__group-title") }, this.props.group.name), this.possibleNonMatchingCarrierWarning(), this.loadSearchArea(), this.guessedLoadsContent());
  },
  possibleExceptionsLink: function() {
    if (!this.state.showExceptions) {
      return /* @__PURE__ */ React.createElement("p", { className: "load-assigner__report-problem" }, "Still issues?", " ", /* @__PURE__ */ React.createElement("a", { onClick: this.toggleExceptions }, "Create an exception"));
    }
  },
  possibleSelectLoadTextNumbering: function() {
    if (this.props.multiCarrier) {
      return /* @__PURE__ */ React.createElement("strong", null, "1.");
    }
  },
  selectLoadText: function() {
    if (!this.state.showSearch) {
      var selectedLoad = this.props.loads.selectedLoad;
      var text = selectedLoad && selectedLoad.load.load_is_auto_confirmed ? this.autoConfirmedLoadHeader() : "Select a load from the loads we identified in the documents. ";
      return /* @__PURE__ */ React.createElement("p", { className: "paragraph" }, /* @__PURE__ */ React.createElement("span", null, this.possibleSelectLoadTextNumbering(), text, "Not the right ones?", " ", /* @__PURE__ */ React.createElement("a", { onClick: this.showSearch }, "Search for another one"), "."));
    }
  },
  autoConfirmedLoadHeader: function() {
    return /* @__PURE__ */ React.createElement(
      AutoConfirmedLoadHeader,
      {
        carrierInvoice: null,
        load: this.props.loads.selectedLoad
      }
    );
  },
  loadsNotFromEmailCarrier: function(loadState) {
    return this.props.email.carrier_id && loadState.load.carrier_id !== this.props.email.carrier_id;
  },
  possibleNonMatchingCarrierWarning: function() {
    if (_.find(this.props.loads.guessed, this.loadsNotFromEmailCarrier)) {
      return /* @__PURE__ */ React.createElement("div", { className: "alert-box--caution" }, /* @__PURE__ */ React.createElement("span", null, "At least one of the following loads is assigned to a", " ", Account.carrierTermLower(), " that does not match the", " ", Account.carrierTermLower(), " assigned to this email."));
    }
  },
  progressArea: function() {
    if (this.state.tab !== "exception") {
      return /* @__PURE__ */ React.createElement("div", { className: "load-assigner__save-buttons" }, /* @__PURE__ */ React.createElement("div", { className: "load-assigner__save-buttons-inner" }, this.invoiceInputFields(), this.carrierChooser(), this.hasInvoices() ? this.invoiceChooser() : "", this.messageOrSave()));
    }
  },
  carrierChooser: function() {
    if (this.props.loads.selected && !this.props.documentBatch.single_carrier) {
      return /* @__PURE__ */ React.createElement("div", { className: "load-assigner__carrier-chooser" }, this.possibleMultipleGuessedCarriersNotification(), /* @__PURE__ */ React.createElement("h6", null, /* @__PURE__ */ React.createElement("span", { className: "paragraph__possible-select-load-text-numbering" }, /* @__PURE__ */ React.createElement("strong", null, "2.")), " ", "Select a ", Account.carrierTermLower(), " for this group (optional):"), /* @__PURE__ */ React.createElement(
        CarrierChooser,
        {
          carrierGuesses: this.props.carrierGuesses(),
          state: this.props.carrierChooserState,
          allowIndexingCustomerOnlyDocuments: this.isIndexCustomerOnlyDocsEnabled(),
          onUpdate: this.props.onCarrierChooserUpdate
        }
      ));
    }
  },
  invoiceChooser: function() {
    if (this.props.selectedCarrierID || this.showInvoiceChooserForCustomerOnlyDocs()) {
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
        CarrierInvoiceChooser,
        {
          loadID: this.props.loads.selectedLoad.load.load_id,
          invoicesForGroup: this.props.invoicesForGroup,
          initialInvoiceId: _.first(
            _.compact(
              _.pluck(this.props.group.documents, "carrier_invoice_id")
            )
          ),
          selectedInvoice: this.props.getSelectedInvoiceForGroup(
            this.noInvoice
          ),
          carrierID: this.props.selectedCarrierID,
          group: this.props.group,
          noInvoice: this.noInvoice,
          currentlyAssignedInvoice: this.props.currentlyAssignedInvoiceForGroup,
          invoiceSelected: this.props.setSelectedInvoiceForGroup
        }
      ));
    }
  },
  messageOrSave: function() {
    let button;
    if (this.state.saving) {
      button = /* @__PURE__ */ React.createElement("button", { disabled: true }, "Saving...");
    } else if (this.props.loads.selected && this.props.selectedCarrierID) {
      let buttonText = "Continue";
      if (this.rerouteNidfToException()) {
        buttonText = "Save as Exception";
      } else if (Account.indexAuditSplitEnabled()) {
        buttonText = "Submit";
      }
      button = /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("button", { className: "button--progress ", onClick: this.assignLoad }, buttonText));
    } else if (this.props.loads.selected) {
      button = /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("button", { className: "button--progress ", onClick: this.assignLoad }, "Continue without selecting ", Account.carrierTermLower()));
    } else {
      button = /* @__PURE__ */ React.createElement("button", { className: "button--disabled", disabled: true }, "Select a load to continue");
    }
    const progressItems = getLoadAssignerProgressItems(
      this.props.loads.selectedLoad,
      this.props.documentBatch,
      this.props.documentGroup,
      this.invoiceDataEntered(),
      this.props.shipmentDocumentSelections,
      this.rerouteNidfToException(),
      this.props.documentLoadRelationships
    );
    return /* @__PURE__ */ React.createElement("div", { className: bem("__actions") }, /* @__PURE__ */ React.createElement(LoadAssignerProgress, { content: button, items: progressItems }));
  },
  guessedLoadsContent: function() {
    if (!this.state.showSearch) {
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
        LoadTable,
        {
          items: this.props.loads.guessed,
          highlightChanged: this.props.highlightReference,
          selectedLoadStateId: this.props.loads.selected,
          highlightedLoads: _.pluck(this.props.loads.guessed, "id"),
          loadsNotFromEmailCarrier: this.loadsNotFromEmailCarrier,
          onSelectionChange: this.props.setSelectedLoad
        }
      ));
    }
  },
  recentlyResolved: function() {
    this.setState({ recentlyResolved: true });
  },
  closeExceptions: function() {
    this.setState({ recentlyResolved: false, showExceptions: false });
  },
  reportProblemContent: function() {
    if (this.state.showExceptions || !this.state.showExceptions && this.state.recentlyResolved) {
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "load-assigner__document-exception-area panel",
          ref: "problemContent"
        },
        /* @__PURE__ */ React.createElement(
          DocumentExceptionArea,
          {
            closeExceptions: this.closeExceptions,
            location: this.props.location,
            recentlyResolved: this.recentlyResolved,
            hasMore: this.props.hasMore,
            documentsExceptionAddedCallback: this.props.documentsExceptionAddedCallback,
            model: this.props.model,
            email: this.props.email,
            carrier: this.props.carrier,
            documentGroup: this.props.documentGroup,
            exceptionResolver: this.props.exceptionResolver,
            exceptionCreator: this.props.exceptionCreator,
            exceptionUpdater: this.props.exceptionUpdater,
            exceptions: this.activeExceptions(),
            scrollUp: this.scrollUp,
            onCancel: this.toggleExceptions
          }
        )
      );
    }
  },
  possibleMultipleGuessedCarriersNotification: function() {
    if (this.props.documentGroup.multiple_guessed_carriers) {
      return /* @__PURE__ */ React.createElement("div", { className: "alert-box--progress" }, "TriumphPay Audit was unable to automatically assign a", " ", Account.carrierTermLower(), " to this group because multiple different", " ", Account.carrierTermLower(), "s or multiple matching", " ", Account.carrierTermLower(), "s with similar names were detected in the documents.");
    }
  },
  activeExceptions: function(givenProps) {
    const props = givenProps ? givenProps : this.props;
    return _.reject(
      props.documentGroup.exception_events,
      _.property("resolved_at")
    );
  },
  loadSearchArea: function() {
    if (this.state.showSearch) {
      return /* @__PURE__ */ React.createElement(
        LoadSearchArea,
        {
          loadsNotFromEmailCarrier: this.loadsNotFromEmailCarrier,
          carrier: this.props.carrier,
          selectedLoadStateId: this.props.loads.selected,
          highlightedLoads: _.pluck(this.props.loads.guessed, "id"),
          searcher: this.props.searcher,
          onSelectionChange: this.props.setSelectedLoad,
          onCancel: this.cancelSearch,
          multiCarrier: this.props.multiCarrier,
          highlightReference: this.props.highlightReference
        }
      );
    }
  },
  scrollUp: function() {
    const container = ReactDOM.findDOMNode(this.refs.problemContent);
    container.scrollIntoView();
  },
  isIndexCustomerOnlyDocsEnabled: function() {
    return Account.currentSettings().allow_indexing_customer_only_documents && this.props.documentBatch.customer_only;
  },
  showInvoiceChooserForCustomerOnlyDocs: function() {
    return this.props.loads.selected && this.props.assignCustomerOnlyDocuments && this.isIndexCustomerOnlyDocsEnabled();
  }
});
